import React from 'react';
import { ShieldCheck, Zap } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function Offer() {
  return <section id="oferta" className="py-20 px-4 bg-white border-t border-slate-200" data-id="element-165">
      <div className="max-w-3xl mx-auto" data-id="element-166">
        <div className="bg-slate-900 rounded-3xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden border border-slate-800" data-id="element-167">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600" data-id="element-168"></div>

          <Zap className="w-16 h-16 text-amber-400 mx-auto mb-6" data-id="element-169" />

          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6" data-id="element-170">
            Recupera el control de tu hogar hoy mismo
          </h2>

          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-171">
            Elimina la pesadilla de los piojos por menos de lo que cuesta un
            combo de comida rápida. Obtén el Protocolo 7 Días Sin Reinfestación
            completo.
          </p>

          <div className="bg-slate-800 rounded-2xl p-6 md:p-8 mb-10 border border-slate-700 max-w-md mx-auto" data-id="element-172">
            <div className="text-teal-400 font-bold uppercase tracking-widest text-sm mb-2" data-id="element-173">
              Precio Especial Hoy
            </div>
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-174">
              <span className="text-6xl font-black text-white" data-id="element-175">$6.39</span>
              <span className="text-2xl text-slate-400" data-id="element-176">USD</span>
            </div>
            <p className="text-slate-400 text-sm line-through" data-id="element-177">
              Precio Regular: $29.00
            </p>
          </div>

          <div className="flex justify-center mb-6" data-id="element-178">
            <CTAButton checkout data-id="element-179" />
          </div>

          <div className="flex items-center justify-center gap-2 text-slate-400 text-sm" data-id="element-180">
            <ShieldCheck className="w-4 h-4" data-id="element-181" />
            <span data-id="element-182">Pago 100% Seguro y Encriptado</span>
          </div>
        </div>
      </div>
    </section>;
}